let de = {
  translations: {
    nav_menu: {
      home: "HOME",
      reserved_area: "RESERVIERTER BEREICH",
      link_reserved_area: "https://www.ecat.it/de/reservierter-bereich/",
      link_home: "https://www.ecat.it/de/",
      products: "PRODUKTE",
      link_products: "https://www.ecat.it/de/produkte/",
      gallery: "GALLERY",
      link_gallery: "https://www.ecat.it/de/bildergalerie/",
      support: "ASSISTENZ",
      link_support: "https://www.ecat.it/de/assistenz/",
      contact_us: "KONTAKTIEREN SIE UNS",
      link_contact_us: "https://www.ecat.it/de/kontakte/",
    },
    nav_menuburger: {
      home: "Home",
      reserved_area: "Reservierter Bereich",
      products: "Produkte",
      gallery: "Gallery",
      support: "Assistenz",
      contact_us: "Kontaktieren Sie Uns",
      link_reserved_area: "https://www.ecat.it/de/reservierter-bereich/",
      link_home: "https://www.ecat.it/de/",
      link_products: "https://www.ecat.it/de/produkte/",
      link_gallery: "https://www.ecat.it/de/bildergalerie/",
      link_support: "https://www.ecat.it/de/assistenz/",
      link_contact_us: "https://www.ecat.it/de/kontakte/",
    },

    footer: {
      privacy_policy: "Privacy policy",
      cookies_policy: "Cookies policy",
      certification: "ISO Certification",
      company_policy: "Company policy",
      condition: "Warranty and condition",
      sales_contract: "EKlok sales contract",
      return_policy: "Return Policy",
      link_privacy_policy: "https://www.ecat.it/de/privacy-policy/",
      link_cookies_policy: "https://www.ecat.it/de/cookie/",
      link_certification: "https://www.ecat.it/src/html/doc/9001_Inglese.pdf",
      link_company_policy: "https://www.ecat.it/de/company_policy/",
      link_condition: "https://www.ecat.it/src/html/doc/sale_conditions.pdf",
      link_sales_contract:
        "https://www.ecat.it/src/html/doc/contratto_eklok_eng.pdf",
      link_return_policy:
        "https://www.ecat.it/src/html/doc/return_policy_eng.pdf",
    },
    device_frame: {
      timeout: "Verbindungszeit abgelaufen",
    },
    errors: {
      user_disabled: 'Konto deaktiviert. Bitte wenden Sie sich an den Support.',
      http_400: "Ungültige Anfrage.",
      http_401:
        "Ungültige Anmeldedaten oder Sitzung abgelaufen. Bitte anmelden.",
      http_403: "Sie haben keine Berechtigung für diese Aktion.",
      http_404: "Ressource nicht gefunden.",
      http_409: "Konflikt mit dem aktuellen Zustand der Ressource.",
      http_422: "Die übermittelten Daten sind ungültig.",
      http_429: "Zu viele Anfragen. Bitte versuche es später erneut.",
      http_500: "Interner Serverfehler. Bitte später erneut versuchen.",
      http_502: "Server nicht erreichbar. Bitte später erneut versuchen.",
      http_503: "Dienst vorübergehend nicht verfügbar.",
      http_504: "Server-Timeout. Bitte später erneut versuchen.",
      network: "Server nicht erreichbar. Überprüfe deine Verbindung.",
      unknown: "Ein unerwarteter Fehler ist aufgetreten.",
    },
  },
};

export default de;
